import http from '../../../service/axios';
import { IBonusHistoryRequest, IBonusHistoryResponse } from '../types/BonusHistory';
import { ILoyaltyQrResponse } from '../types/LoyaltyQr';

/**
 * Дольше не ждём: без сети запрос иначе висит до таймаута браузера, а
 * пользователь всё это время стоит у кассы с пустым экраном. Восемь секунд —
 * запас на плохой мобильный интернет, после которого сеть считаем отсутствующей.
 */
const QR_REQUEST_TIMEOUT_MS = 8000;

const languageHeader = () => ({
  Language: localStorage.getItem('language') || 'ru',
});

export const loyaltyAPI = {
  getQr: async () =>
    await http.get<ILoyaltyQrResponse>('loyalty/qr', {
      params: {
        // Источник называем сами, а не полагаемся на угадывание по Origin:
        // кассе и отчётам важно, что код показан из Telegram.
        source: 'telegram',
      },
      headers: languageHeader(),
      timeout: QR_REQUEST_TIMEOUT_MS,
    }),
  /**
   * История баллов — JSON-тело, поэтому Content-Type задаём явно: иначе
   * перехватчик axios подставит multipart. Даты — UTC без `Z`, как в примере
   * бэкенда. Отказ приходит 200-м с `success: false` — разбирает сервис.
   */
  getBonusHistory: async (body: IBonusHistoryRequest) =>
    await http.post<IBonusHistoryResponse>('balance-history', body, {
      headers: { 'Content-Type': 'application/json', ...languageHeader() },
    }),
};
